import {
  PageHeader,
  Form,
  Row,
  Col,
  Input,
  Select,
  Button,
  message,
  DatePicker,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { UsergroupAddOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import { dateFormat } from "../../utils/Constants";

import { v4 as uuid } from "uuid";
import { useApiContext } from "../../hooks/useApiContext";
import { Items } from "../../services/items";
import apis from "../../services/apis";

import InvoiceItems from "../../components/invoice/InvoiceItems";
import InvoicePrint from "../../components/invoice/InvoicePrint";

export default function AddInvoice() {
  const {
    projects,
    invoicedispatch,
    projectdispatch,
    businessdispatch,
    businesses,
    items,
    invoiceItemdispatch,
  } = useApiContext();
  const [loading, setLoading] = useState(false);
  const [invoiceForm] = Form.useForm();
  const [projectData, setProjectData] = useState();
  const [busineesData, setBusineesData] = useState();
  const [getbusinees, setGetBusinees] = useState();
  const [projectId, setProjectId] = useState("");
  const [projectCompany, setProjectCompany] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [issueDate, setIssueDate] = useState("");
  const [productVat, setproductVat] = useState("");
  const [customField1, setCustomField1] = useState("");
  const [customField2, setCustomField2] = useState("");
  const [customField3, setCustomField3] = useState("");
  const [customField4, setCustomField4] = useState("");
  const [customField5, setCustomField5] = useState("");
  const [customField6, setCustomField6] = useState("");
  const [enablePrinting, setEnablePrinting] = useState(false);
  const [isSaved, setIsSaved] = useState(true);

  let printRef = useRef();

  useEffect(() => {
    if (projects.length < 1) {
      apis.Projects.list(projectdispatch);
    }

    if (businesses.length < 1) {
      const data = apis.Businesses.list(businessdispatch);
      setBusineesData(data);
    }
    setInvoiceNo(`BGTINV${Math.floor(Math.random() * 100000 + 10)}`);
  }, [businesses.length < 1, projects.length < 1]);

  const getProjectData = (value) => {
    setproductVat("");
    invoiceForm.setFieldsValue({ projectVat: "" });
    const data = projects.find((x) => x.id == value);
    setProjectData(data);
    setProjectId(data.id);
    setProjectCompany(data.company.companyName);
    if (data.vatNumber) {
      invoiceForm.setFieldsValue({ projectVat: data.vatNumber });
      setproductVat(data.vatNumber);
    }
    console.log("Project data", data);
  };
  const getBusinessData = (value) => {
    const data = businesses.filter((x) => x.id == value);
    setGetBusinees(data);
    console.log("Business Data", data);
  };
  const onFinish = (values) => {
    setLoading(true);
    let newValues = {
      ...values,
      id: uuid(),
      invoiceItems: items,
      invoiceNumber: invoiceNo,
      customField1: customField1,
      customField2: customField2,
      customField3: issueDate,
      customField4: customField4,
      customField5: customField5,
      customField6: customField6,
      invoiceAmount: Number(
        (
          items.reduce((a, b) => a + b.amount, 0) +
          items.reduce((a, b) => a + b.amount, 0) * 0.15
        ).toFixed(2)
      ),
      vatAmount: Number(
        (items.reduce((a, b) => a + b.amount, 0) * 0.15).toFixed(2)
      ),
    };
    apis.Invoices.create(invoicedispatch, newValues).then((res) => {
      setLoading(false);
      invoiceForm.resetFields();
      setEnablePrinting(true);
      setIsSaved(false);
    });
  };
  const onFinishFailed = (error) => {
    message.error(error);
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint: () => {
      Items.remove(invoiceItemdispatch, []);
      setCustomField1("");
      setCustomField2("");
      setCustomField3("");
      setCustomField4("");
      setCustomField5("");
      setCustomField6("");
      invoiceForm.resetFields();
      setEnablePrinting(false);
      setIsSaved(true);
    },
  });

  return (
    <div style={{ position: "relative", marginBottom: "40px" }}>
      <PageHeader
        className="site-page-header"
        onBack={() => null}
        title="Add Invoice"
        subTitle="Enter below details to add invoice"
      />
      {/* Form for adding invoice */}
      <Form
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        name="basic"
        form={invoiceForm}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        className="gx-signin-form"
      >
        <Row style={{ marginTop: "20px" }}>
          <Col span={12}>
            <Form.Item
              label="Select Project"
              name="projectId"
              rules={[{ required: true, message: "Please select project" }]}
            >
              <Select
                placeholder="Select project"
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
                onChange={getProjectData}
              >
                {projects.map((item) => (
                  <Select.Option value={item.id}>
                    {item.projectName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Project VAT"
              name="projectVat"
              rules={[{ required: true, message: "Please enter project vat" }]}
            >
              <Input
                placeholder="Project VAT Number"
                onChange={(e) => setproductVat(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Select Business"
              name="businessId"
              rules={[{ required: true, message: "Please select business" }]}
            >
              <Select
                placeholder="Select Business"
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
                onChange={getBusinessData}
              >
                {businesses.map((item) => (
                  <Select.Option value={item.id}>
                    {item.businessName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Invoice Number"
              name="invoiceNumber"
              initialValue={invoiceNo}
            >
              <label>{invoiceNo}</label>
            </Form.Item>
            <Input.Group compact style={{ paddingBottom: "10px" }}>
              <Input
                name="customField1"
                onChange={(e) => setCustomField1(e.target.value)}
                style={{ width: "25%", marginLeft: "25px" }}
                placeholder="Contact Label"
              />
              <Input
                name="customField2"
                onChange={(e) => setCustomField2(e.target.value)}
                style={{ width: "60%" }}
                placeholder="Contact details"
              />
            </Input.Group>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Company Name"
              name="invoiceDate"
              style={{ width: "60%", marginLeft: "80px" }}
              rules={[
                { required: true, message: "Please select invoice date" },
              ]}
            >
              <Input.Group compact style={{ paddingBottom: "10px" }}>
                <Input
                  name="customField4"
                  value={projectCompany != "" ? projectCompany : ""}
                  onChange={(e) => setCustomField4(e.target.value)}
                  style={{ width: "100%" }}
                  placeholder="Company Name"
                />
              </Input.Group>
            </Form.Item>

            <Input.Group compact style={{ paddingBottom: "10px" }}>
              <Input
                name="customField5"
                onChange={(e) => setCustomField5(e.target.value)}
                style={{ width: "30%", marginLeft: "25px" }}
                placeholder="Contact Label"
              />
              <Input
                name="customField6"
                onChange={(e) => setCustomField6(e.target.value)}
                style={{ width: "60%" }}
                placeholder="Contact details"
              />
            </Input.Group>

            <Form.Item
              label="Invoice Date"
              name="invoiceDate"
              rules={[
                { required: true, message: "Please select invoice date" },
              ]}
            >
              <DatePicker
                placeholder="DD/MM/YYYY"
                format={dateFormat}
                onChange={(date, dateString) => {
                  setInvoiceDate(dateString);
                }}
                style={{ width: "92%", borderRadius: "5px" }}
              />
              {/* <Input type="date" onChange={(e) => setInvoiceDate(e.target.value)}/> */}
            </Form.Item>
            <Form.Item
              label="Invoice Start date"
              name="startDate"
              rules={[
                { required: true, message: "Please select invoice date" },
              ]}
            >
              <DatePicker
                placeholder="DD/MM/YYYY"
                format={dateFormat}
                onChange={(date, dateString) => {
                  setStartDate(dateString);
                }}
                style={{ width: "92%", borderRadius: "5px" }}
              />
              {/* <Input type="date" onChange={(e) => setStartDate(e.target.value)}/> */}
            </Form.Item>
            <Form.Item
              label="Invoice End Date"
              name="endDate"
              rules={[
                { required: true, message: "Please select invoice date" },
              ]}
            >
              <DatePicker
                placeholder="DD/MM/YYYY"
                format={dateFormat}
                onChange={(date, dateString) => {
                  setEndDate(dateString);
                }}
                style={{ width: "92%", borderRadius: "5px" }}
              />
              {/* <Input type="date" onChange={(e) => setEndDate(e.target.value)}/> */}
            </Form.Item>
          </Col>
        </Row>
        <div style={{ position: "absolute", bottom: "-45px", left: "0px" }}>
          {isSaved && (
            <Button
              loading={loading}
              type="primary"
              htmlType="submit"
              icon={<UsergroupAddOutlined />}
              style={{ marginRight: "5px" }}
            >
              Add Invoice
            </Button>
          )}
          {enablePrinting && (
            <Button onClick={handlePrint} type="primary">
              Print Invoice
            </Button>
          )}
        </div>
      </Form>

      {/* Component for adding items to invoice */}
      <InvoiceItems saved={isSaved} />
      {/* Print template component */}
      <div style={{ display: "none" }}>
        <InvoicePrint
          ref={printRef}
          invoiceNo={invoiceNo}
          startDate={startDate}
          endDate={endDate}
          invoiceDate={invoiceDate}
          projectData={projectData}
          getbusinees={getbusinees}
          projectVat={productVat}
          customField1={customField1}
          customField2={customField2}
          customField3={customField3}
          customField4={customField4}
          customField5={customField5}
          customField6={customField6}
          issueDate={issueDate}
        />
      </div>
    </div>
  );
}
